import { render, staticRenderFns } from "./tableForm-bak.vue?vue&type=template&id=7ff5e1c2&scoped=true&"
import script from "./tableForm-bak.vue?vue&type=script&lang=js&"
export * from "./tableForm-bak.vue?vue&type=script&lang=js&"
import style0 from "./tableForm-bak.vue?vue&type=style&index=0&id=7ff5e1c2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ff5e1c2",
  null
  
)

export default component.exports